import $ from 'jquery'

$(document).ready(function () {
    //heightFix();
})

export const heightFix = () => {
    var fullHeight = $(document).height();
    var act = fullHeight - 100;
    console.log("fullHeight", fullHeight);
    $('body').css('height', fullHeight + 'px');
    $('.main').css('height', fullHeight + 'px');
    $('#root').css('height', fullHeight + 'px');
    //$('#overlayPreloader').css('height', fullHeight + 'px');
    $('#activityWidget').css('height', fullHeight + 'px');
    $('#activity-list').css('height', act + 1 + 'px');
    $('#activity-list-results').css('height', act + 'px');
    $('#tv-ctl').css('height', act + 1 + 'px');
    $('#movies').css('height', fullHeight + 'px');
    $('#ico-guest-services').css('height', fullHeight + 'px');
    $('#guest-Req-col-1').css('height', act + 'px');
    $('#guest-Req-col-2').css('height', act + 'px');
    $('#scrollThumb').css('height', (act - 148) + 'px');
    //alert($('#movies').hasClass("contentSection"));
}

export const heightFixer = () => {
    //console.log("heightFixer called")
    $(document).ready(function () {
        if ($(document).width() > 600) {
            var fullHeight = $(document).height();
            $('body').css('height', fullHeight + 'px');
            $('#usrInfo').height($('#usrPromo img').height());
            //     console.log($('#usrPromo img').height());
            $('#usrCtrl').height($('#usrPromo img').height() - $('#usrProfile').height() - 5);
        }
    });
}

export const forMobileMenu = (status) => {
    $(document).ready(function () {
        if (status) {
            $('#myBody').addClass("mobile no-scroll");
        } else {
            $('#myBody').removeClass("mobile no-scroll");
        }
    })
}


//mobile no-scroll